// src/Components/Slider/Slider.js

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./slider.css";
import React from "react";
import Slider1 from "../../Assets/slider_vegan_fried_chicken_pcs.png";
import Slider2 from "../../Assets/slider_banh_mi.png";
import Slider4 from "../../Assets/slider_vegan_pistachio_croissant_081626.png";
import SliderCoconutCroissant from "../../Assets/slider_coconut_croissant.png";
import Slider5 from "../../Assets/slider_order_now.png";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const slides = [
  {
    id: 5,
    image: Slider5,
    title: "Order Now",
    description: "Place your order online for delivery or pickup through Toast.",
    buttonText: "Order Now",
    buttonLink: "https://order.toasttab.com/online/dong-hung-vien",
    isExternal: true,
  },
  {
    id: 4,
    image: Slider4,
    title: "Vegan Pistachio Croissant",
    description: "Indulgent from the very first bite.",
    buttonText: "Learn More",
    buttonLink: "/vegan-pistachio-croissant",
    // MODIFICATION: Added a smaller font size for this long title
    customTitleStyle: {
      whiteSpace: { xs: "normal", sm: "nowrap" },
      fontSize: { xs: "20px", sm: "34px", md: "34px" }, // Reduced from 40px
    },
  },
  {
    id: 6,
    image: SliderCoconutCroissant,
    title: "Coconut Croissant\n3 for $5 is back!",
    buttonText: "Learn More",
    buttonLink: "/coconut-croissant",
    customTitleStyle: {
      whiteSpace: "pre-line",
      fontSize: { xs: "20px", sm: "34px", md: "34px" },
    },
  },
  {
    id: 2,
    image: Slider2,
    title: "Traditional & Vegan Bánh Mì",
    description: "Every bánh mì is crafted with authentic, fresh Vietnamese flavors.",
    buttonText: "Learn More",
    buttonLink: "/banh-mi",
    // MODIFICATION: Added a smaller font size for this long title
    customTitleStyle: {
      whiteSpace: { xs: "normal", sm: "nowrap" },
      fontSize: { xs: "20px", sm: "34px", md: "34px" }, // Reduced from 40px
    },
  },
  {
    id: 1,
    image: Slider1,
    title: "Fried Oyster Mushroom",
    description: "Reimagined as a crispy vegan chick'n sandwich. Also comes à la carte.",
    buttonText: "Learn More",
    buttonLink: "https://www.donghungvienbakery.com/vegan-fried-chicken-pieces",
  },
];

const MuiReactSlider = () => {
  return (
    <Box
      sx={{
        width: "100%",
        margin: "auto",
        overflow: "hidden",
      }}
    >
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop
        spaceBetween={50}
        slidesPerView={1}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.id}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                aspectRatio: "16 / 9",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: { xs: "center", md: "left" },
                color: "white",
                backgroundColor: "#000",
                textShadow: "0px 2px 5px rgba(0, 0, 0, 0.8)",
              }}
            >
              {/* OPTIMIZATION: Image is now an <img> tag for lazy loading */}
              <img
                src={slide.image}
                alt={slide.title}
                // The first image loads eagerly, the rest are lazy loaded
                loading={index === 0 ? "eager" : "lazy"}
                // Gives the first image priority to improve LCP metric
                fetchPriority={index === 0 ? "high" : "auto"}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              />

              {/* Your content, with a higher z-index to appear on top of the image */}
              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                  background: "rgba(0, 0, 0, .5)",
                  padding: 5,
                  maxWidth: "590px",
                  width: "60%",
                  borderRadius: "10px",
                }}
              >
                <Typography
                  variant="h3"
                  gutterBottom
                  sx={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    maxWidth: "90%",
                    fontSize: { xs: "20px", sm: "40px", md: "40px" },
                    fontFamily:
                      "Abhaya Libre, Georgia, Times New Roman, serif;",
                    ...slide.customTitleStyle,
                  }}
                >
                  {slide.title}
                </Typography>
                {slide.description && (
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      maxWidth: "90%",
                      fontSize: { xs: "14px", sm: "14px", md: "16px" },
                    }}
                  >
                    {slide.description}
                  </Typography>
                )}
                {slide.isExternal ? (
                  <a
                    href={slide.buttonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      fontFamily: "Open Sans, Arial, sans-serif",
                      color: "#fff",
                      borderRadius: "30px",
                      fontSize: "14px",
                      fontWeight: 700,
                      background: "#00AAE3",
                      padding: "10px 50px",
                      display: "inline-block",
                      marginTop: "14px",
                      lineHeight: "1.5em",
                      textShadow: "none",
                      textDecoration: "none",
                    }}
                  >
                    {slide.buttonText}
                  </a>
                ) : (
                  <Link
                    variant="contained"
                    color="primary"
                    to={slide.buttonLink}
                    style={{
                      fontFamily: "Open Sans, Arial, sans-serif",
                      color: "#fff",
                      borderRadius: "30px",
                      fontSize: "14px",
                      fontWeight: 700,
                      background: "#00AAE3",
                      padding: "10px 50px",
                      display: "inline-block",
                      marginTop: "14px",
                      lineHeight: "1.5em",
                      textShadow: "none",
                      textDecoration: "none",
                    }}
                  >
                    {slide.buttonText}
                  </Link>
                )}
              </Box>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default MuiReactSlider;